import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Packages
import shortid from 'shortid';

class SelectFormInput extends Component {
  static propTypes = {
    // Required
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),

    //Optional
    errorMessage: PropTypes.string,
    label: PropTypes.string,
    optionalClasses: PropTypes.string,
    selectOptions: PropTypes.array,
    children: PropTypes.node,
    placeholder: PropTypes.string,
    multiselect: PropTypes.bool,
    showError: PropTypes.bool,
    disabled: PropTypes.bool,
    onBlur: PropTypes.func,
  }

  renderLabel(label) {
    const { disabled } = this.props;

    return label
    ? (
        <label className={disabled ? 'disabled' : null}>
          {label}
        </label>
      )
    : ''
  }

  renderErrorMessage = (errorMessage) => {
    return errorMessage ? (
      <div className="input-error-message">
        {errorMessage}
      </div>
    ) : '';
  }

  handleRemoveButtonClick = (event) => {
    event.preventDefault();
    this.props.handleInputRemoval();
  }

  renderRemoveButton() {
    const { handleInputRemoval } = this.props;

    return handleInputRemoval
    ? (
      <a className="input-delete-button" onClick={(event)=> this.handleRemoveButtonClick(event)}>
        <svg className="icon"><use xlinkHref="#trash-can" /></svg>
      </a>
    ) : null
  }

  render() {
    const {
      errorMessage,
      label,
      name,
      onChange,
      placeholder,
      value,
      showError,
      children,
      optionalClasses,
      selectOptions,
      multiselect,
      disabled,
      handleInputRemoval
    } = this.props;

    return (
      <div
        className={`input-container select-container${optionalClasses ? ' ' + optionalClasses : ''}${errorMessage ? ' error' : ''}${handleInputRemoval ? ' removable' : ''}`}
      >
        {this.renderLabel(label)}
        <div className="input-container-inner">
          <div className="select-input-container">
            <select
              name={name}
              value={value}
              onChange={onChange}
              disabled={disabled}
              multiple={multiselect}
            >
              {
                placeholder &&
                <option value="" disabled defaultValue>
                  {placeholder}
                </option>
              }
              {selectOptions.map((option) => {
                return (
                  <option key={shortid.generate()} value={option.value}>
                    {option.label}
                  </option>
                );
              })}
            </select>
          </div>
          {this.renderRemoveButton()}
        </div>
        {showError && this.renderErrorMessage(errorMessage)}
        {children}
      </div>
    )
  }
}


export default SelectFormInput;



// WEBPACK FOOTER //
// ./src/components/Global/Forms/SelectFormInput.js